import { render, staticRenderFns } from "./PasienEdit.vue?vue&type=template&id=0aeef8dc&scoped=true"
import script from "./PasienEdit.vue?vue&type=script&lang=js"
export * from "./PasienEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeef8dc",
  null
  
)

export default component.exports